import { render, staticRenderFns } from "./viewableImg.vue?vue&type=template&id=97f42b54&scoped=true"
import script from "./viewableImg.vue?vue&type=script&lang=ts"
export * from "./viewableImg.vue?vue&type=script&lang=ts"
import style0 from "./viewableImg.vue?vue&type=style&index=0&id=97f42b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f42b54",
  null
  
)

export default component.exports